import { I18n, useTranslate } from "@similarweb/i18n-provider";
import { GlobeBlue } from "@similarweb/icons/illustrations";
import { PromoBanner } from "@similarweb/ui-components";

import { StyledCountriesPromoBannerWrapper } from "app/pages/website-analysis/geography/StyledComponents";
import { allTrackers } from "app/services/track/track";
import { goToPackagesPage } from "app/UtilitiesAndConstants/UtilityFunctions/goToPackagesPage";

const StyledCountriesPromoBannerComponent = () => {
    const { translate } = useTranslate();

    const handleBannerTrialButtonClick = () => {
        allTrackers.dispatchTrackEvent("internal link", "click", "Geography/go to package page/country filter");
        goToPackagesPage();
    };

    return (
        <StyledCountriesPromoBannerWrapper data-automation="website-analysis-geography-countries-promo-banner">
            <PromoBanner>
                <GlobeBlue />
                <PromoBanner.Content>
                    <PromoBanner.Title>{translate("trial.banner.countries.title")}</PromoBanner.Title>
                    <PromoBanner.Description>
                        <I18n
                            dangerouslySetInnerHTML={true}
                            i18nKey={"trial.banner.countries.subtitle"}
                        />
                    </PromoBanner.Description>
                </PromoBanner.Content>
                <PromoBanner.Cta
                    type="outlined"
                    onClick={handleBannerTrialButtonClick}
                >
                    {translate("explore.our.packages")}
                </PromoBanner.Cta>
            </PromoBanner>
        </StyledCountriesPromoBannerWrapper>
    );
};

export default StyledCountriesPromoBannerComponent;
